import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M2.7 7.72a4 4 0 0 1 4-4h6.6a4 4 0 0 1 4 4v4.56a4 4 0 0 1-4 4H6.7a4 4 0 0 1-4-4V7.72Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M2 7.72a4.7 4.7 0 0 1 4.7-4.7h6.6a4.7 4.7 0 0 1 4.7 4.7v4.56a4.7 4.7 0 0 1-4.7 4.7H6.7a4.7 4.7 0 0 1-4.7-4.7V7.72Zm4.7-3.3a3.3 3.3 0 0 0-3.3 3.3v4.56a3.3 3.3 0 0 0 3.3 3.3h6.6a3.3 3.3 0 0 0 3.3-3.3V7.72a3.3 3.3 0 0 0-3.3-3.3H6.7Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M4.902 8.645a1.7 1.7 0 0 1 1.7-1.7h1.644c.777 0 1.407.63 1.407 1.407a.7.7 0 1 1-1.4 0V8.35s0-.002-.002-.003a.008.008 0 0 0-.002-.002H6.602a.3.3 0 0 0-.3.3v2.71a.3.3 0 0 0 .3.3h1.566a.085.085 0 0 0 .085-.085.7.7 0 1 1 1.4 0c0 .82-.665 1.485-1.485 1.485H6.602a1.7 1.7 0 0 1-1.7-1.7v-2.71Zm5.445 0a1.7 1.7 0 0 1 1.7-1.7h1.644c.777 0 1.406.63 1.406 1.407a.7.7 0 1 1-1.4 0v-.003l-.001-.002-.003-.002h-1.646a.3.3 0 0 0-.3.3v2.71a.3.3 0 0 0 .3.3h1.646l.003-.002a.007.007 0 0 0 .001-.002v-.003a.7.7 0 1 1 1.4 0c0 .777-.63 1.407-1.406 1.407h-1.644a1.7 1.7 0 0 1-1.7-1.7v-2.71Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=ClosedCaptionFilledIcon20.js.map